module.exports = __webpack_public_path__ + "img/software-thumb-3.201ad255.png";